module.exports = __webpack_public_path__ + "static/Overview-9f7e2b28e4ffd265b27fa619e2706ad2.png";